import { render, staticRenderFns } from "./mc-summary.tests.vue?vue&type=template&id=fb20c5ac&scoped=true"
import script from "./mc-summary.tests.vue?vue&type=script&lang=ts"
export * from "./mc-summary.tests.vue?vue&type=script&lang=ts"
import style0 from "./mc-summary.tests.vue?vue&type=style&index=0&id=fb20c5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb20c5ac",
  null
  
)

export default component.exports